import React from 'react';
import { useFocusedField } from '../../contexts/focused-field-provider';
import { useFieldAttributes } from '../../services/field-attributes';
import { EmailMistypeSuggestionWUT } from '../email-validation/email-mistype-suggestion-wut';
import { useEmailMistypeCheck } from '../email-validation/use-email-mistype-check';
import { TextInputFieldWUT } from './text-input-field-wut';
export const EmailInputFieldWUT = (props)=>{
    const { isMistyped, suggestedEmail, validate } = useEmailMistypeCheck({
        email: props.value,
        hasError: props.hasError
    });
    const { setFocusedFieldId } = useFocusedField();
    const isEditable = !props.readOnly && !props.disabled;
    const activeSuggestion = isMistyped && isEditable ? suggestedEmail : null;
    const { suggestionId } = useFieldAttributes(props.id);
    const applySuggestion = ()=>{
        props.onChange(activeSuggestion);
        setFocusedFieldId(props.id);
    };
    const handleBlur = ()=>{
        validate();
        props.onBlur?.();
    };
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        type: "email",
        suggestion: activeSuggestion ?? undefined,
        additionalInfo: /*#__PURE__*/ React.createElement(React.Fragment, null, props.additionalInfo, /*#__PURE__*/ React.createElement(EmailMistypeSuggestionWUT, {
            id: suggestionId,
            suggestedEmail: activeSuggestion,
            onFix: applySuggestion
        })),
        onBlur: handleBlur
    });
};

//# sourceMappingURL=email-input-field-wut.js.map